import { render, staticRenderFns } from "./EventTaskForm.vue?vue&type=template&id=257392e2"
import script from "./EventTaskForm.vue?vue&type=script&lang=js"
export * from "./EventTaskForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports